
import _ from "lodash";
import { projectTypes } from "constants/projectTypes";
import hedgeTypes from "constants/hedgeTypes";
import { map } from "constants/screenElements/dealViewMetric";

import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatDate,
  formatNumberTwoDecimal,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal,
  formatRateThreeDecimal,
  formatDscr
} from "./formatters";

const {
  CASH_EQUITY,
  EXPENSE_RATIO,
  CURRENT_BALANCE,
  UNFUNDED_COMMITMENT,
  CURRENT_RATE,
  PROJECTED_RATE,
  UPCOMING_PAYMENT,
  MONTHS_UNTIL_MATURITY,
  IO_REMAINING,
  MAX_RECOURSE,
  DSCR,
  DEBT_YIELD,
  LTV,
  PREPAYMENT,
  COVENANT_TEST_FREQUENCY,
  DEBT_RSF,
  DEBT_MF_UNIT,
  PROJECTED_EXIT_DATE,
  CAP_RATE,
  PROJECT_TYPE,
  PURCHASE_DATE,
  PURCHASE_PRICE,
  MATURITY_DATE,
  EXTENDED_MATURITY_DATE,
  LENDER,
  BORROWING_ENTITY,
  HEDGE_TYPE,
  HEDGE_MATURITY,
  HEDGE_MTM,
  NOI,
  OCCUPANCY,
  APPRAISED_VALUE,
  EQUITY,
  CURRENT_BALANCE_SENIOR_SUPP,
  ALL_IN_RATE,
  LTV_SUBORDINATE,
  DEBT_YIELD_SUBORDINATE,
  DSCR_LENDER_SUBORDINATE,
  DSCR_ACTUAL_SUBORDINATE,
  NOI_ACTUAL,
  DSCR_ACTUAL,
  SUPPLEMENTAL_LOAN_PROCEEDS,
  INTERNAL_EQUITY_OWNERSHIP,
  EXTERNAL_EQUITY_OWNERSHIP,
  REFI_CASH_OUT,
  ALL_IN_EFFECTIVE_RATE,
  DEVELOPMENT_COST,
  SQUARE_FEET,
  MF_UNITS,
  SALES_PRICE,
  EXIT_CAP
} = map;

export default {
  [CASH_EQUITY]: formatCurrency,
  [APPRAISED_VALUE]: notImplemented,
  [BORROWING_ENTITY]: notImplemented,
  [CAP_RATE]: formatRate,
  [COVENANT_TEST_FREQUENCY]: notImplemented,
  [CURRENT_BALANCE]: notImplemented,
  [CURRENT_BALANCE_SENIOR_SUPP]: notImplemented,
  [CURRENT_RATE]: notImplemented,
  [DEBT_MF_UNIT]: notImplemented,
  [DEBT_YIELD]: notImplemented,
  [DEBT_RSF]: notImplemented,
  [DSCR]: formatDscr,
  [EQUITY]: formatCurrencyTwoDecimal,
  [EXPENSE_RATIO]: notImplemented,
  [EXTENDED_MATURITY_DATE]: notImplemented,
  [HEDGE_MATURITY]: notImplemented,
  [HEDGE_MTM]: notImplemented,
  [HEDGE_TYPE]: notImplemented,
  [IO_REMAINING]: notImplemented,
  [LENDER]: notImplemented,
  [LTV]: notImplemented,
  [MAX_RECOURSE]: notImplemented,
  [MATURITY_DATE]: notImplemented,
  [MONTHS_UNTIL_MATURITY]: notImplemented,
  [NOI]: formatCurrency,
  [OCCUPANCY]: formatRate,
  [PROJECTED_RATE]: notImplemented,
  [PROJECTED_EXIT_DATE]: notImplemented,
  [PREPAYMENT]: notImplemented,
  [PURCHASE_PRICE]: formatCurrency,
  [PURCHASE_DATE]: notImplemented,
  [PROJECT_TYPE]: notImplemented,
  [UPCOMING_PAYMENT]: notImplemented,
  [UNFUNDED_COMMITMENT]: notImplemented,
  [ALL_IN_RATE]: formatRate,
  [LTV_SUBORDINATE]: formatRate,
  [DEBT_YIELD_SUBORDINATE]: formatRate,
  [DSCR_LENDER_SUBORDINATE]: formatDscr,
  [DSCR_ACTUAL_SUBORDINATE]: formatDscr,
  [NOI_ACTUAL]: formatCurrencyTwoDecimal,
  [DSCR_ACTUAL]: formatDscr,
  [SUPPLEMENTAL_LOAN_PROCEEDS]: formatCurrency,
  [INTERNAL_EQUITY_OWNERSHIP]: formatRate,
  [EXTERNAL_EQUITY_OWNERSHIP]: formatRate,
  [REFI_CASH_OUT]: formatCurrency,
  [ALL_IN_EFFECTIVE_RATE]: formatRate,
  [DEVELOPMENT_COST]: formatCurrency,
  [SQUARE_FEET]: formatInteger,
  [MF_UNITS]: formatInteger,
  [SALES_PRICE]: formatCurrency,
  [EXIT_CAP]: formatRate
};
